// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4s-0";
export var eligibilityCardNotEligible = "_4s-1";